import React from 'react';
import { Transition } from '@headlessui/react';
import BookingWorkflowSidebar from './BookingWorkflowSidebar';
import FloatingBookingButton from './FloatingBookingButton';
import { useBookingFlow } from '../../contexts/BookingFlowContext';

// Desktop sidebar is a flex child with a fixed 360px width — a content-
// sized slot in the pair-centered row. Kept stable across all steps so the
// sidebar doesn't visibly shift when the user advances through the flow.
const SIDEBAR_TRACK_CLASS =
  'hidden lg:flex lg:w-[360px] lg:flex-shrink-0 lg:order-2 flex-col space-y-8 w-full';

/**
 * Right-rail sidebar group. Business identity has moved to PublicBookingHero
 * (left column, services step). The sidebar now only shows BookingWorkflowSidebar
 * once services are selected, on all steps.
 */
const BookingSidebarGroup = () => {
  const {
    selectedServices,
    bookingWorkflowRef,
  } = useBookingFlow();

  const hasSelectedServices = selectedServices.length > 0;

  return (
    <>
      {/* Right Column — desktop sidebar. Fades in once a service is selected
          so the layout promotion reads as a response to the user's action. */}
      <Transition
        as="div"
        show={hasSelectedServices}
        appear
        enter="transition-opacity duration-300 ease-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150 ease-in"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className={SIDEBAR_TRACK_CLASS}
      >
        <BookingWorkflowSidebar sticky={true} />
      </Transition>

      {/* Mobile sidebar */}
      {hasSelectedServices && (
        <div
          ref={bookingWorkflowRef}
          className="block lg:hidden mt-8 mb-20 animate-in fade-in slide-in-from-bottom-4 duration-300 ease-out"
        >
          <BookingWorkflowSidebar />
        </div>
      )}

      {/* Floating button */}
      {hasSelectedServices && <FloatingBookingButton />}
    </>
  );
};

export default BookingSidebarGroup;
